module.exports = __webpack_public_path__ + "img/watching.22140ac1.svg";